import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { formElementTypes } from "../../../../../utils/Constant";
import MultiInputFields from "../html-form/multi-input-fields";

export default function MultiInputPreview({
  element,
  inputValueChange,
  disabled,
  isQC,
  showRequiredField,
}: any) {
  const [column1Cells, setColumn1Cells] = useState([]);
  const [column2Cells, setColumn2Cells] = useState([]);
  const [column3Cells, setColumn3Cells] = useState([]);

  useEffect(() => {
    if (element && element?.type === formElementTypes.multiInput) {
      multiInputChildElements();
    }
  }, [element]); // eslint-disable-line

  const multiInputChildElements = () => {
    const filterColumn1 = element?.childElements
      .filter(
        (element: any) => element?.multiInputElementSettings?.column === 1
      )
      .sort(
        (a: any, b: any) =>
          a?.multiInputElementSettings?.row - b?.multiInputElementSettings?.row
      );
    const filterColumn2 = element?.childElements
      .filter(
        (element: any) => element?.multiInputElementSettings?.column === 2
      )
      .sort(
        (a: any, b: any) =>
          a?.multiInputElementSettings?.row - b?.multiInputElementSettings?.row
      );
    const filterColumn3 = element?.childElements
      .filter(
        (element: any) => element?.multiInputElementSettings?.column === 3
      )
      .sort(
        (a: any, b: any) =>
          a?.multiInputElementSettings?.row - b?.multiInputElementSettings?.row
      );
    setColumn1Cells(filterColumn1);
    setColumn2Cells(filterColumn2);
    setColumn3Cells(filterColumn3);
  };

  const updatedValue = (value: string, childElementId: string) => {
    if (inputValueChange) {
      inputValueChange({ id: childElementId, answer: value });
    }
  };

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      {column1Cells.length > 0 && (
        <Box flex={1}>
          {column1Cells.map((cell: any, index: number) => (
            <Box
              key={index}
              sx={{
                mt: 2,
                width: column2Cells.length > 0 ? "calc(100% - 8px)" : "100%",
              }}
            >
              <MultiInputFields
                cell={cell}
                updatedValue={updatedValue}
                disabled={disabled}
                isQC={isQC}
                showRequiredField={showRequiredField}
              />
            </Box>
          ))}
        </Box>
      )}
      {column2Cells.length > 0 && (
        <Box flex={1}>
          {column2Cells.map((cell: any, index: number) => (
            <Box
              key={index}
              sx={{
                mt: 2,
                ml: 1,
                width:
                  column3Cells.length > 0
                    ? "calc(100% - 16px)"
                    : "calc(100% - 8px)",
              }}
            >
              <MultiInputFields
                cell={cell}
                updatedValue={updatedValue}
                disabled={disabled}
                isQC={isQC}
                showRequiredField={showRequiredField}
              />
            </Box>
          ))}
        </Box>
      )}
      {column3Cells.length > 0 && (
        <Box flex={1}>
          {column3Cells.map((cell: any, index: number) => (
            <Box
              key={index}
              sx={{
                mt: 2,
                ml: 1,
                width: "calc(100% - 8px)",
              }}
            >
              <MultiInputFields
                cell={cell}
                updatedValue={updatedValue}
                disabled={disabled}
                isQC={isQC}
                showRequiredField={showRequiredField}
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
